export default __webpack_public_path__ + "static/media/tiivii-guia-escritorio-1.f53c3fe9.png";